import { memo } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { appointmentDraftSelectors } from '~/api';

import { Section } from '~/components/review-details/section';
import { SectionItem } from '~/components/review-details/section-item';

import { PATH_NAMES } from '../../../../constants';

const formatAddressToMultipleLines = (address) => (
  <span>
    {address.street1}
    {address.street1 ? <br /> : null}
    {address.street2}
    {address.street2 ? <br /> : null}
    {address.street3}
    {address.street3 ? <br /> : null}
    {address.street4}
    {address.street4 ? <br /> : null}
    {address.city}
    {address.city ? <br /> : null}
    {address.county}
    {address.county ? <br /> : null}
    {address.postcode}
  </span>
);

export const YourAddress = memo(({ history, address }) => (
  <Section
    history={history}
    editPath={PATH_NAMES.SELECT_ADDRESS}
    analyticsSectionType="address"
    category="Property Address"
  >
    <SectionItem
      key="propertyAddress"
      title="Property address"
      definition={formatAddressToMultipleLines(address)}
    />
  </Section>
));

YourAddress.displayName = 'YourAddress';

export const mapStateToProps = (state) => ({
  address: appointmentDraftSelectors.selectDraftAddress(state),
});

export const ConnectedYourAddress = withRouter(connect(mapStateToProps)(YourAddress));

YourAddress.propTypes = {
  history: PropTypes.shape({}).isRequired,
  address: PropTypes.shape({}).isRequired,
};
